import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {NavBar} from 'Components/Nav/NavBar';
import s from './styles/Blogs.module.scss';
import Footer from "./Footer";
import {getDeviceId, isLoggedIn, SessionContext} from "../../Utils/sessions";
import {Root} from "../../Api/Root";
import {useScroll} from "../../Utils/helpers";
import {logElementInteraction} from "../../Api/Utils/referral";

export const BACKUP_BLOGS = [
    {
        byline: "Samantha Steff",
        university: "Columbia University",
        description: "Columbia University junior, Samantha Seiff, reflects on her experience as a college student in the Big Apple.",
        uri: "college-life-in-nyc",
        title: "College Life in NYC",
        coverUrl: "https://cdn.cassy.dev/columbia.png",
        readTime: 15,
        likes: 12,
        commentCount: 1
    },
    {
        byline: "",
        university: "",
        description: "College student shares their thoughts on attending community college and the transfer process.",
        uri: "transfer",
        title: "Community College to Four Year University",
        coverUrl: "https://cdn.cassy.dev/transfer.png",
        readTime: 15,
        likes: 12,
        commentCount: 1
    },
    {
        byline: "",
        university: "University of California, San Diego",
        description: "Top 12 must have items for Freshman year",
        uri: "college-essentials",
        title: "12 College Essentials",
        coverUrl: "https://cdn.cassy.dev/ucal.png",
        readTime: 15,
        likes: 12,
        commentCount: 1
    },
    {
        byline: "Briana Buckley",
        university: "Rice University",
        description: "Graduate student Brianna gives her take on the pros and cons of attending grad school.",
        uri: "grad-school",
        title: "Is Grad School Right for Me?",
        coverUrl: "https://cdn.cassy.dev/scale.png",
        readTime: 15,
        likes: 12,
        commentCount: 1
    },
    {
        byline: "Anonymous",
        university: "",
        description: "Student breaks down the steps you can take as a high schooler, to help get into college.",
        uri: "beating-the-odds",
        title: "How to Beat the Odds",
        coverUrl: "https://cdn.cassy.dev/decision-fork.png",
        readTime: 15,
        likes: 12,
        commentCount: 1
    }
]

export const HelpCenter = () => {
    const {session} = useContext(SessionContext);
    const [blogs, setBlogs] = useState(undefined)
    const isScrolled = useScroll(5)

    useEffect(() => {
        Root.bloggingApi.getBlogPosts({}).then((res) => {
            setBlogs(res.data)
        }).catch(() => {
            setBlogs(BACKUP_BLOGS)
        })
    }, []);

    useEffect(() => {
        logElementInteraction({
            elementId: isLoggedIn(session) ? 'blogs::all::authenticated' : 'blogs::all::public',
            type: 'VIEW',
            deviceId: getDeviceId(),
            data: localStorage.getItem('userInfo'),
            source: 'WEB'
        }).then(() => {
        }).catch(() => {
        });
    }, []);

    return <>
        <div className={s.blog}>
            <div className={`${s.navBarContainer} ${isScrolled ? s.navBarScrolled : ''}`}>
                <NavBar dark={true}/>
            </div>
            <div className={`${s.blogsHeader}`}>
                <div className={`${s.blogsHeaderText}`}>
                    <h1><strong>Help Center</strong></h1>
                    <h3 className={s.subheader}>
                        The help you need, all in one place
                    </h3>
                </div>
            </div>
            <div className={'mt-3'}>
                <div className={s.blogFinder}>
                    <main className={s.blogListContainer}>
                        <HelpArticleList blogs={blogs}/>
                    </main>
                </div>
            </div>
        </div>
        <Footer/>
    </>
}

export const HelpArticleList = ({articles}) => {

    return <>
        <div className={`${s.blogsContent} `}>
            {articles ?
                <>
                    {articles.length > 0 ?
                        articles.map((b, idx) => <HelpArticleTile key={idx} blog={b}/>) :
                        <>
                            <div className={'text-center'}><h3>No articles found</h3></div>
                        </>
                    }
                </> :
                <>
                    <HelpArticleTile/>
                    <HelpArticleTile/>
                    <HelpArticleTile/>
                </>
            }
        </div>
    </>
}

HelpArticleList.propTypes = {
    articles: PropTypes.arrayOf(PropTypes.shape({
        uri: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        byline: PropTypes.string,
        coverUrl: PropTypes.string.isRequired,
        university: PropTypes.string,
        dateString: PropTypes.string,
        readTime: PropTypes.number,
        likes: PropTypes.number,
        commentCount: PropTypes.number,
        description: PropTypes.string,
        audioUrl: PropTypes.string,
        audio: PropTypes.bool,
        timestamp: PropTypes.number,
    }))
};


const HelpArticleTile = ({blog}) => {
    const [loading, setLoading] = useState(true)

    const handleClick = () => {
        if (blog?.uri) {
            window.location.href = `${window.location.href.split('/')[0]}/blog/posts/${blog.uri}`;
        }
    }

    return (
        <>
            {blog ?
                <>
                    <div className={s.desktop}>
                        <div className={`${s.blogTile} mb-5`} onClick={handleClick}>
                            <div className={s.grid}>
                                <div className={s.blogTileImageContainer}>
                                    <img className={s.blogTileImage} src={blog.coverUrl} alt={'blog cover'}
                                         onLoad={() => setLoading(false)}/>
                                    {loading &&
                                        <div className={`${s.blogTileImagePlaceholder} ${s.shimmerBg}`}
                                             style={{zIndex: 0}}/>}
                                </div>

                                <div className={s.blogInfo}>
                                    <p>{blog.byline || "Anonymous"} | {blog.university || "Unknown University"}</p>
                                    <div className={s.blogTileTitle}><strong>{blog.title}</strong></div>
                                    <p>{blog.description}</p>
                                    <div>
                  <span style={{
                      height: '200px',
                      borderRadius: '20px',
                      objectFit: 'cover',
                      width: '100%'
                  }}>{blog.readTime} minute read</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`${s.mobile} mb-4`}>
                        <div role={'link'}
                             onClick={handleClick}
                             className={s.blogTile}>
                            <img className={s.blogTileImage} src={blog.coverUrl} alt={'blog cover'}
                                 onLoad={() => setLoading(false)}/>
                            <p className={`mb-1`}>{blog.byline || "Anonymous"} | {blog.university || "Unknown University"}</p>
                            <div className={s.blogInfo}>
                                <p className={s.blogTileTitle}>
                                    {blog.title}
                                </p>
                                <p className={s.blogTileSubtitle}>
                                    {blog.description}
                                </p>
                            </div>
                        </div>
                    </div>
                </> :
                <>
                    <div>
                        <div className={`${s.blogTile} mb-5`} onClick={handleClick}>
                            <div className={s.grid}>
                                <div className={`${s.blogTileImage} ${s.shimmerBg}`}
                                     style={{
                                         height: '200px',
                                         borderRadius: '20px',
                                         objectFit: 'cover',
                                         width: '100%'
                                     }}/>
                                <div>
                                    <div className={`${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                    <div className={`${s.subtitlePlaceHolder} ${s.shimmerBg}`}/>
                                    <div className={`${s.textPlaceHolder} ${s.shimmerBg}`}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    );
};

HelpArticleTile.propTypes = {
    blog: PropTypes.shape({
        uri: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        byline: PropTypes.string,
        coverUrl: PropTypes.string.isRequired,
        university: PropTypes.string,
        dateString: PropTypes.string,
        readTime: PropTypes.number,
        likes: PropTypes.number,
        commentCount: PropTypes.number,
        description: PropTypes.string,
        audioUrl: PropTypes.string,
        audio: PropTypes.bool,
        timestamp: PropTypes.number,
    }),
};
